import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteKiloGLMFlow(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteKiloGLMFlow = (flowId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`kilo-glm-flows/${flowId}/`);
  };

  return useMutation(deleteKiloGLMFlow, {
    onSuccess: (_data, flowId) => {
      // Spec: remove the deleted flow's detail, invalidate the list so it refetches.
      queryClient.removeQueries(['kilo-glm-flows', flowId]);
      queryClient.invalidateQueries(['kilo-glm-flows'], { exact: true });
    },
  });
}
